import React from 'react';
import { ReactComponent as Icon } from '../../../assets/icon-affiliate.svg';
import createSvgIcon from '../../../shared/utils/create-svg-icon';

export const AffiliateIcon = createSvgIcon(<Icon />, 'AffiliateIcon');
